import { computed, createElementBlock, openBlock, createElementVNode, createVNode, unref, withCtx, renderSlot } from "vue";
import { DtInput, DtCheckbox } from "@dialpad/dialtone-vue";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
const _hoisted_1 = { class: "d-d-flex d-ai-flex-end" };
const _hoisted_2 = { class: "d-fl-grow1" };
const _hoisted_3 = { class: "d-input__label-text d-label--sm" };
const _hoisted_4 = { class: "d-pl6" };
const __default__ = {
  name: "DtcControlNumber"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: Number,
      default: () => Number()
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const props = __props;
    function isNaN(value) {
      return Number.isNaN(value);
    }
    const inputValue = computed(() => {
      return isNaN(props.value) ? null : props.value;
    });
    function toggleNaN(e) {
      emit(VALUE_UPDATE_EVENT, e ? NaN : 0);
    }
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, [
          createVNode(unref(DtInput), {
            value: inputValue.value,
            disabled: __props.disabled || isNaN(__props.value),
            type: "number",
            size: "sm",
            onInput: _cache[0] || (_cache[0] = (e) => emit(unref(VALUE_UPDATE_EVENT), parseInt(e)))
          }, {
            labelSlot: withCtx(() => [
              createElementVNode("span", _hoisted_3, [
                renderSlot(_ctx.$slots, "default")
              ])
            ]),
            _: 3
          }, 8, ["value", "disabled"])
        ]),
        createElementVNode("div", _hoisted_4, [
          createVNode(unref(DtCheckbox), {
            label: "NaN",
            checked: isNaN(__props.value),
            disabled: __props.disabled,
            onInput: toggleNaN
          }, null, 8, ["checked", "disabled"])
        ])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_number.vue.js.map
